import React from "react";
import "./styles/colors.less";
import { Space } from "antd";
import { AxDivider } from "@dynata/axiom3";

class Colors extends React.Component {
  render() {
    return (
      <div className="section colors" id="colors">
        <Space direction="vertical" size="large">
          <h3>Colors</h3>
          <p>
            All resources in the `dist` folder of the Axiom package are
            framework agnostic, which means they could be imported and used
            outside React projects.
            <br />
            This section describes Axiom color tokens usage. The text inside the
            color palettes states the unique color token names for css & less.
          </p>

          <AxDivider orientation="left" plain>
            Usage: colors.css
          </AxDivider>

          <ul>
            <li>
              Import colors.css in your project's CSS file:
              <br />
              <code className="inline">
                @import "@dynata/axiom3/dist/colors.css"
              </code>
            </li>

            <li>
              Usage example:
              <br />
              <code className="inline">
                background-color: var(--primary-blue-normal);
              </code>
            </li>
          </ul>

          <AxDivider orientation="left" plain>
            Usage: colors.less
          </AxDivider>

          <ul>
            <li>
              Import colors.less in your project's LESS file:
              <br />
              <code className="inline">
                @import "@dynata/axiom3/dist/colors.less"
              </code>
            </li>

            <li>
              Usage example:
              <br />
              <code className="inline">
                background-color: @primary-blue-normal;
              </code>
            </li>
          </ul>
        </Space>
        <AxDivider orientation="left" plain>
          primary-dynata
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#f4f7fb", color: "#1b365d" }}>
            @primary-dynata-brighter <br /> #f4f7fb <br />{" "}
            var(--primary-dynata-brighter)
          </span>
          <span style={{ background: "#e2e9f4", color: "#1b365d" }}>
            @primary-dynata-bright <br /> #e2e9f4 <br />{" "}
            var(--primary-dynata-bright)
          </span>
          <span style={{ background: "#bacae1" }}>
            @primary-dynata-lighter <br /> #bacae1 <br />{" "}
            var(--primary-dynata-lighter)
          </span>
          <span style={{ background: "#6787b7" }}>
            @primary-dynata-light <br /> #6787b7 <br />{" "}
            var(--primary-dynata-light)
          </span>
          <span style={{ background: "#1e528f" }}>
            @primary-dynata-normal <br /> #1e528f <br />{" "}
            var(--primary-dynata-normal)
          </span>
          <span style={{ background: "#1b365d" }}>
            @primary-dynata-dark <br /> #1b365d <br />{" "}
            var(--primary-dynata-dark)
          </span>
        </div>
        <AxDivider orientation="left" plain>
          primary-blue
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#f2f6fc", color: "#243889" }}>
            @primary-blue-brighter
            <br /> #f2f6fc <br /> var(--primary-blue-brighter)
          </span>
          <span style={{ background: "#dae3f7", color: "#243889" }}>
            @primary-blue-bright
            <br /> #dae3f7 <br /> var(--primary-blue-bright)
          </span>
          <span style={{ background: "#aec1ea" }}>
            @primary-blue-light
            <br /> #aec1ea <br /> var(--primary-blue-light)
          </span>
          <span style={{ background: "#577dd3" }}>
            @primary-blue-normal
            <br /> #577dd3 <br /> var(--primary-blue-normal)
          </span>
          <span style={{ background: "#475fc2" }}>
            @primary-blue-dark
            <br /> #475fc2 <br /> var(--primary-blue-dark)
          </span>
          <span style={{ background: "#243889" }}>
            @primary-blue-deep
            <br /> #243889 <br /> var(--primary-blue-deep)
          </span>
        </div>
        <AxDivider orientation="left" plain>
          secondary-blue
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#edf8fc", color: "#243889" }}>
            @secondary-blue-brighter
            <br /> #edf8fc <br /> var(--secondary-blue-brighter)
          </span>
          <span style={{ background: "#cdeaf9", color: "#243889" }}>
            @secondary-blue-bright
            <br /> #cdeaf9 <br /> var(--secondary-blue-bright)
          </span>
          <span style={{ background: "#95cfec" }}>
            @secondary-blue-light
            <br /> #95cfec <br /> var(--secondary-blue-light)
          </span>
          <span style={{ background: "#3ea8dd" }}>
            @secondary-blue-normal
            <br /> #3ea8dd <br /> var(--secondary-blue-normal)
          </span>
          <span style={{ background: "#217ab5" }}>
            @secondary-blue-dark
            <br /> #217ab5 <br /> var(--secondary-blue-dark)
          </span>
          <span style={{ background: "#0b508c" }}>
            @secondary-blue-deep
            <br /> #0b508c <br /> var(--secondary-blue-deep)
          </span>
        </div>
        <AxDivider orientation="left" plain>
          secondary-magenta
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#fceef6", color: "#7e0447" }}>
            @secondary-magenta-brighter
            <br /> #fceef6 <br /> var(--secondary-magenta-brighter)
          </span>
          <span style={{ background: "#fbd0e7", color: "#7e0447" }}>
            @secondary-magenta-bright
            <br /> #fbd0e7 <br /> var(--secondary-magenta-bright)
          </span>
          <span style={{ background: "#f893ca" }}>
            @secondary-magenta-light
            <br /> #f893ca <br /> var(--secondary-magenta-light)
          </span>
          <span style={{ background: "#d0368b" }}>
            @secondary-magenta-normal
            <br /> #d0368b <br /> var(--secondary-magenta-normal)
          </span>
          <span style={{ background: "#a8276e" }}>
            @secondary-magenta-dark
            <br /> #a8276e <br /> var(--secondary-magenta-dark)
          </span>
          <span style={{ background: "#7e0447" }}>
            @secondary-magenta-deep
            <br /> #7e0447 <br /> var(--secondary-magenta-deep)
          </span>
        </div>
        <AxDivider orientation="left" plain>
          secondary-orange
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#fff2f0", color: "#aa2915" }}>
            @secondary-orange-brighter
            <br /> #fff2f0 <br /> var(--secondary-orange-brighter)
          </span>
          <span style={{ background: "#ffd7d1", color: "#aa2915" }}>
            @secondary-orange-bright
            <br /> #ffd7d1 <br /> var(--secondary-orange-bright)
          </span>
          <span style={{ background: "#ffa799" }}>
            @secondary-orange-light
            <br /> #ffa799 <br /> var(--secondary-orange-light)
          </span>
          <span style={{ background: "#f5735f" }}>
            @secondary-orange-normal
            <br /> #f5735f <br /> var(--secondary-orange-normal)
          </span>
          <span style={{ background: "#ec4a31" }}>
            @secondary-orange-dark
            <br /> #ec4a31 <br /> var(--secondary-orange-dark)
          </span>
          <span style={{ background: "#aa2915" }}>
            @secondary-orange-deep
            <br /> #aa2915 <br /> var(--secondary-orange-deep)
          </span>
        </div>
        <AxDivider orientation="left" plain>
          danger
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#fff0f2", color: "#890212" }}>
            @danger-brighter
            <br /> #fff0f2 <br /> var(--danger-brighter)
          </span>
          <span style={{ background: "#ffccd3", color: "#890212" }}>
            @danger-bright
            <br /> #ffccd3 <br /> var(--danger-bright)
          </span>
          <span style={{ background: "#ff8f9d" }}>
            @danger-light
            <br /> #ff8f9d <br /> var(--danger-light)
          </span>
          <span style={{ background: "#e94458" }}>
            @danger-normal
            <br /> #e94458 <br /> var(--danger-normal)
          </span>
          <span style={{ background: "#c61025" }}>
            @danger-dark
            <br /> #c61025 <br /> var(--danger-dark)
          </span>
          <span style={{ background: "#890212" }}>
            @danger-deep
            <br /> #890212 <br /> var(--danger-deep)
          </span>
        </div>
        <AxDivider orientation="left" plain>
          warning
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#fff6f0", color: "#ab3a0a" }}>
            @warning-brighter
            <br /> #fff6f0 <br /> var(--warning-brighter)
          </span>
          <span style={{ background: "#ffe2cc", color: "#ab3a0a" }}>
            @warning-bright
            <br /> #ffe2cc <br /> var(--warning-bright)
          </span>
          <span style={{ background: "#fdcaa3" }}>
            @warning-light
            <br /> #fdcaa3 <br /> var(--warning-light)
          </span>
          <span style={{ background: "#fca360" }}>
            @warning-normal
            <br /> #fca360 <br /> var(--warning-normal)
          </span>
          <span style={{ background: "#d46b2f" }}>
            @warning-dark
            <br /> #d46b2f <br /> var(--warning-dark)
          </span>
          <span style={{ background: "#ab3a0a" }}>
            @warning-deep
            <br /> #ab3a0a <br /> var(--warning-deep)
          </span>
        </div>
        <AxDivider orientation="left" plain>
          info
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#fefaf0", color: "#a8660f" }}>
            @info-brighter
            <br /> #fefaf0 <br /> var(--info-brighter)
          </span>
          <span style={{ background: "#fef1d2", color: "#a8660f" }}>
            @info-bright
            <br /> #fef1d2 <br /> var(--info-bright)
          </span>
          <span style={{ background: "#fce3ab" }}>
            @info-light
            <br /> #fce3ab <br /> var(--info-light)
          </span>
          <span style={{ background: "#f9cc67" }}>
            @info-normal
            <br /> #f9cc67 <br /> var(--info-normal)
          </span>
          <span style={{ background: "#d19834" }}>
            @info-dark
            <br /> #d19834 <br /> var(--info-dark)
          </span>
          <span style={{ background: "#a8660f" }}>
            @info-deep
            <br /> #a8660f <br /> var(--info-deep)
          </span>
        </div>

        <AxDivider orientation="left" plain>
          positive
        </AxDivider>
        <div className="d-grid">
          <span style={{ background: "#f7fcfb", color: "#0b7063" }}>
            @positive-brighter
            <br /> #f7fcfb <br /> var(--positive-brighter)
          </span>
          <span style={{ background: "#d5f1e9", color: "#0b7063" }}>
            @positive-bright
            <br /> #d5f1e9 <br /> var(--positive-bright)
          </span>
          <span style={{ background: "#9ddccb" }}>
            @positive-light
            <br /> #9ddccb <br /> var(--positive-light)
          </span>
          <span style={{ background: "#52c1a3" }}>
            @positive-normal
            <br /> #52c1a3 <br /> var(--positive-normal)
          </span>
          <span style={{ background: "#289982" }}>
            @positive-dark
            <br /> #289982 <br /> var(--positive-dark)
          </span>
          <span style={{ background: "#0b7063" }}>
            @positive-deep
            <br /> #0b7063 <br /> var(--positive-deep)
          </span>
        </div>

        <AxDivider orientation="left" plain>
          gray
        </AxDivider>
        <div className="d-grid">
          <span
            style={{
              background: "#ffffff",
              color: "#717171",
              border: "1px solid #E3E3E3",
            }}
          >
            @gray-1
            <br /> #ffffff <br /> var(--gray-1)
          </span>
          <span style={{ background: "#fafafa", color: "#717171" }}>
            @gray-2
            <br /> #fafafa <br /> var(--gray-2)
          </span>
          <span style={{ background: "#f5f5f5", color: "#717171" }}>
            @gray-3
            <br /> #f5f5f5 <br /> var(--gray-3)
          </span>
          <span style={{ background: "#f0f0f0", color: "#717171" }}>
            @gray-4
            <br /> #f0f0f0 <br /> var(--gray-4)
          </span>
          <span style={{ background: "#E3E3E3", color: "#717171" }}>
            @gray-5
            <br /> #E3E3E3 <br /> var(--gray-5)
          </span>
          <span style={{ background: "#c6c6c6" }}>
            @gray-6
            <br /> #c6c6c6 <br /> var(--gray-6)
          </span>
          <span style={{ background: "#aaaaaa" }}>
            @gray-7
            <br /> #aaaaaa <br /> var(--gray-7)
          </span>
          <span style={{ background: "#8E8E8E" }}>
            @gray-8
            <br /> #8E8E8E <br /> var(--gray-8)
          </span>
          <span style={{ background: "#717171" }}>
            @gray-9
            <br /> #717171 <br /> var(--gray-9)
          </span>
          <span style={{ background: "#555555" }}>
            @gray-10
            <br /> #555555 <br /> var(--gray-10)
          </span>
          <span style={{ background: "#393939" }}>
            @gray-11
            <br /> #393939 <br /> var(--gray-11)
          </span>
          <span style={{ background: "#1C1C1C" }}>
            @gray-12
            <br /> #1C1C1C <br /> var(--gray-12)
          </span>
          <span style={{ background: "#000000" }}>
            @gray-13
            <br /> #000000 <br /> var(--gray-13)
          </span>
        </div>
      </div>
    );
  }
}
export default Colors;
